import {
  useGqlIncrementAnalysisReportShareMutation,
  useGqlUpdateAnalysisReportScrapMutation,
} from 'generated/graphql'

const useIncreaseCount = () => {
  const [updateAnalysisReportScrap] = useGqlUpdateAnalysisReportScrapMutation()

  const [incrementAnalysisReportShareMutation] =
    useGqlIncrementAnalysisReportShareMutation()

  const incrementAnalysisReportShare = (reportId: string) => {
    incrementAnalysisReportShareMutation({
      variables: {
        analysisReportId: reportId,
      },
    })
  }

  return { updateAnalysisReportScrap, incrementAnalysisReportShare }
}

export default useIncreaseCount
